import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import { siteInfo } from '@/mocks/siteInfo';

function BrandIntro() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            品牌介绍
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              {siteInfo.longDescription}
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-4">
              我们深知，娱乐圈的光鲜亮丽背后，往往隐藏着不为人知的真相。吃瓜黑料正是为了揭开这些真相而存在。我们不做任何一方的代言人，只做事实的搬运工和真相的守门人。
            </p>
            <p className="text-sm text-foreground-700 leading-relaxed">
              自{siteInfo.founded}成立以来，我们已经累计发布了超过
              <strong className="text-primary-600">{siteInfo.stats.articles.toLocaleString()}</strong>
              篇文章，收获了
              <strong className="text-primary-600">{siteInfo.stats.dailyVisitors.toLocaleString()}</strong>
              日活跃用户，独家爆料超过
              <strong className="text-primary-600">{siteInfo.stats.exclusiveReveals}</strong>
              条。我们始终坚信：真实，是娱乐新闻的生命线。
            </p>
          </div>
          <div className="rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20modern%20editorial%20newsroom%20with%20warm%20lighting%2C%20journalists%20working%20at%20desks%20with%20multiple%20screens%2C%20red%20accent%20decor%2C%20professional%20news%20media%20office%2C%20clean%20and%20organized%20workspace%2C%20warm%20natural%20light%20from%20windows&width=600&height=450&seq=chigua-about-brand&orientation=landscape"
              alt="吃瓜黑料编辑部"
              className="w-full h-full object-cover"
              title="吃瓜黑料编辑部"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { value: `${(siteInfo.stats.articles / 10000).toFixed(1)}万+`, label: '累计爆料', icon: 'ri-article-line' },
    { value: `${(siteInfo.stats.dailyVisitors / 10000).toFixed(0)}万+`, label: '日活用户', icon: 'ri-user-line' },
    { value: `${siteInfo.stats.exclusiveReveals}+`, label: '独家内幕', icon: 'ri-spy-line' },
    { value: '24h', label: '全天候更新', icon: 'ri-time-line' },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100/60">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${stat.icon} text-accent-600 text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">{stat.value}</div>
              <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section className="py-12 md:py-16">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-mail-line text-xl text-primary-600"></i>
            </div>
            <h4 className="text-sm font-heading font-bold text-foreground-900 mb-2">爆料邮箱</h4>
            <p className="text-sm text-foreground-500 break-all">{siteInfo.contact.email}</p>
          </div>

          <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-wechat-line text-xl text-primary-600"></i>
            </div>
            <h4 className="text-sm font-heading font-bold text-foreground-900 mb-2">微信公众号</h4>
            <p className="text-sm text-foreground-500">{siteInfo.contact.wechat}</p>
          </div>

          <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-weibo-line text-xl text-primary-600"></i>
            </div>
            <h4 className="text-sm font-heading font-bold text-foreground-900 mb-2">官方微博</h4>
            <p className="text-sm text-foreground-500">{siteInfo.contact.weibo}</p>
          </div>
        </div>

        <div className="mt-8 p-6 rounded-lg bg-background-100/60 border border-background-200/70">
          <h4 className="text-sm font-heading font-bold text-foreground-900 mb-3 flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-500"></i>
            爆料人保护承诺
          </h4>
          <p className="text-sm text-foreground-600 leading-relaxed">
            我们郑重承诺：对所有爆料人的身份信息严格保密，绝不向任何第三方透露信息源。
            采用端到端加密通信方式，确保爆料内容在传输过程中的安全性。
            对于有重大价值的独家爆料，我们将提供丰厚的爆料奖励。
          </p>
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: siteInfo.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 bg-background-100/60">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {siteInfo.faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h4 className="text-sm font-heading font-bold text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 flex-shrink-0 transition-colors">
                  <i className="ri-add-line text-sm text-foreground-500 group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于我们 - ${siteInfo.name}`,
    description: siteInfo.description,
    url: 'https://chiguaheila.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: 'https://chiguaheila.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16">
          <div className="chigua-container">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="text-center mb-12 md:mb-16">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                关于吃瓜黑料
              </h1>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto leading-relaxed">
                {siteInfo.tagline} —— {siteInfo.description}
              </p>
            </div>

            <BrandIntro />
          </div>
          <StatsSection />
          <div className="chigua-container">
            <ContactSection />
          </div>
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}